module.exports = __webpack_public_path__ + "img/teams-close-icon.2c9db6f6.svg";